import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { Head } from '@/components/ui/Typography/Heading/Head';
export const LinkHead = (props) => {
    const { baseTextColor = 'primary', children, className = '', isGroup = false, isNormal = false, size, tagName, } = props;
    return (_jsx(Head, Object.assign({ className: clsx('hover:underline hover:cursor-pointer hover:text-link', isGroup &&
            'group-hover:underline group-hover:cursor-pointer group-hover:text-link', className), color: baseTextColor, isNormal: isNormal, size: size, tagName: tagName }, { children: children })));
};
